/**
 * Becker Orthopedic
 *
 * Main site javascript
 */

// jQuery
import $ from "jquery";
window.jQuery = $;
window.$ = $;

// Vendor JavaScript
require("slick-carousel/slick/slick");
require("foundation-sites");

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

// Vendor SASS
//import "font-awesome/scss/font-awesome.scss";
//import "motion-ui/motion-ui.scss";

// Vendor CSS
import "animate.css/animate.min.css";

// Site specific SCSS
import "@/scss/site.scss";

// Fancybox
Fancybox.bind(".fancybox");

/**
 * jQuery initialized
 */
$(function () {
	// Initialize Foundation
	$(document).foundation();

	// Free Shipping Banner
	if (localStorage && localStorage.getItem("hideShippingCallout") === "1") {
		$("#shippingCallout").hide();
	} else {
		$("#shippingCallout").show();
	}
	$("#shippingCallout").on("close.zf.trigger", function () {
		if (confirm("Keep the shipping banner hidden?")) {
			localStorage.setItem("hideShippingCallout", "1");
		}
	});

	// News Banner
	if (localStorage && localStorage.getItem("hideNewsCallout") === "1") {
		$("#newsCallout").hide();
	} else {
		$("#newsCallout").show();
	}
	$("#newsCallout").on("close.zf.trigger", function () {
		if (confirm("Keep the news information banner hidden?")) {
			localStorage.setItem("hideNewsCallout", "1");
		}
	});
});